function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useState } from 'react';
import classnames from 'classnames';
import uniqueId from 'lodash.uniqueid';
import { Button, Collapse, CustomInput, Icon, ListGroupItem } from '@appfolio/react-gears'; // TODO any to <T>

var ListItem = function ListItem(_ref) {
  var render = _ref.children,
      className = _ref.className,
      color = _ref.color,
      _ref$expanded = _ref.expanded,
      defaultExpanded = _ref$expanded === void 0 ? false : _ref$expanded,
      item = _ref.item,
      onExpand = _ref.onExpand,
      onSelect = _ref.onSelect,
      select = _ref.select,
      selected = _ref.selected,
      props = _objectWithoutProperties(_ref, ["children", "className", "color", "expanded", "item", "onExpand", "onSelect", "select", "selected"]);

  var isExpandable = onExpand !== undefined; // @ts-ignore

  var ExpandedItem = isExpandable ? onExpand(item) : undefined;

  var _useState = useState(defaultExpanded),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = useState(function () {
    return uniqueId('listitem-');
  }),
      _useState4 = _slicedToArray(_useState3, 1),
      id = _useState4[0];

  return /*#__PURE__*/React.createElement(ListGroupItem, _extends({
    color: selected ? 'primary' : color,
    className: classnames('rounded-0', className)
  }, props), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, select && /*#__PURE__*/React.createElement("div", {
    className: "pr-2"
  }, /*#__PURE__*/React.createElement(CustomInput, {
    id: id,
    type: select,
    checked: selected,
    label: /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "Select"),
    onChange: function onChange(e) {
      return onSelect(item, e.target.checked);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "mr-auto w-100 px-2"
  }, render(item, selected)), isExpandable && /*#__PURE__*/React.createElement(Button, {
    color: "link",
    onClick: function onClick() {
      return setExpanded(!expanded);
    },
    className: "mr-n3",
    style: {
      visibility: ExpandedItem === undefined ? 'hidden' : 'visible'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevron-".concat(expanded ? 'up' : 'down')
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Expand"))), ExpandedItem === undefined || /*#__PURE__*/React.createElement(Collapse, {
    isOpen: expanded
  }, ExpandedItem));
};

ListItem.displayName = "ListItem";
ListItem.displayName = 'ListItem';
export default ListItem;